<div class="flex flex-col gap-12">
  <app-back-button text="{{ 'page.projects.title' | translate }}" link="/panel/projects/list"></app-back-button>

  <div class="flex items-center justify-between">
    <app-title>{{ 'page.project-detail.title' | translate:{ name : (project$ | async)?.name } }}</app-title>

    <ng-container *ngIf="project$ | async as project">
      <div class="flex items-center gap-2" appProjectAdminAccess [project]="project">
        <app-button text="{{ 'action.edit' | translate }}" variant="plain" icon="/assets/images/icon-pencil.svg" (click)="editProject()"></app-button>
        <app-button text="{{ 'action.delete' | translate }}" variant="danger" icon="/assets/images/icon-trash.svg" (click)="deleteProject()"></app-button>
      </div>
    </ng-container>
  </div>

  <app-tabs>
    <app-tab text="{{ 'page.project-detail.tab.map' | translate }}" link="map"></app-tab>
    <app-tab text="{{ 'page.project-detail.tab.info' | translate }}" link="info"></app-tab>
    <app-tab text="{{ 'page.project-detail.tab.point-clouds' | translate }}" link="point-clouds"></app-tab>
<!--    <app-tab text="{{ 'page.project-detail.tab.photos' | translate }}" link="photos"></app-tab>-->
  </app-tabs>

  <div>
    <router-outlet></router-outlet>
  </div>
</div>
